import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  AchRelationshipsOptions = 'AchRelationshipsOptions',
  FundingOptions = 'FundingOptions',
  WithdrawalOptions = 'WithdrawalOptions',
  TransferAccountsOptions = 'TransferAccountsOptions',
  ApexAccountStatusSummary = 'ApexAccountStatusSummary',
  MaxAchRelationshipsOptions = 'MaxAchRelationshipsOptions',
}

export const queryKeys = {
  achRelationships: (clientId: string, managedAccountId: string) => [
    QueryFeature.TransferMoney,
    QueryKey.AchRelationshipsOptions,
    clientId,
    managedAccountId,
  ],

  fundingOptions: (clientId: string, managedAccountId: string) => [
    QueryFeature.TransferMoney,
    QueryKey.FundingOptions,
    clientId,
    managedAccountId,
  ],

  withdrawalOptions: (clientId: string, managedAccountId: string) => [
    QueryFeature.TransferMoney,
    QueryKey.WithdrawalOptions,
    clientId,
    managedAccountId,
  ],

  transferAccountsOptions: (clientId: string, managedAccountId: string) => [
    QueryFeature.TransferMoney,
    QueryKey.TransferAccountsOptions,
    clientId,
    managedAccountId,
  ],

  apexAccountStatusSummary: (clientId: string, id: string) => [
    QueryFeature.TransferMoney,
    QueryKey.ApexAccountStatusSummary,
    clientId,
    id,
  ],

  maxAchRelationships: (clientId: string) => [
    QueryFeature.TransferMoney,
    QueryKey.MaxAchRelationshipsOptions,
    clientId,
  ],
};
